import IFXFieldWrapper from "./IFXFieldWrapper";

export { IFXFieldWrapper };
